module.exports = __webpack_public_path__ + "static/media/resurs.02a52a99.svg";